import styled, { css } from 'styled-components';
import { ICON_SIZES } from '../../../../icon';
import Spinner, { SPINNER_SIZE, SpinnerSVG, SpinnerText } from '../../../../spinner';
import Typography from '../../../../typography';
import { getIconUrl, pxToRem } from '../../../../../design-tokens/style-utilities';
import { getGenericInputPaddingStyles, getOnDarkStyles, getOnLightStyles, getOnMediumStyles, } from '../../../styles/common.styled';
const PADDING_RIGHT = 30;
const SELECT_HEIGHT = 56;
export const selectSpinnerStyles = ({ theme }) => css `
	opacity: 1;
	position: absolute;
	top: 50%;
	right: 0;
	transform: translate(-${pxToRem(theme.spacing[200])}, -50%);

	${SpinnerSVG} {
		width: calc(${pxToRem(SPINNER_SIZE.medium)} - ${pxToRem(theme.spacing[200])});
		height: calc(${pxToRem(SPINNER_SIZE.medium)} - ${pxToRem(theme.spacing[200])});
	}

	${SpinnerText} {
		white-space: nowrap;
	}
`;
export const SelectSpinner = styled(Spinner) `
	${selectSpinnerStyles}
`;
export const selectContainerStyles = ({ theme, $loading, $disabled, }) => css `
	position: relative;
	display: block;
	width: 100%;

	${!$loading &&
    css `
		&::after {
			content: '';
			mask: url('${getIconUrl('chevron-down', 'ui')}') no-repeat center right;
			position: absolute;
			top: 50%;
			right: ${pxToRem(theme.spacing['300'])};
			transform: translateY(-50%);
			display: block;
			height: ${pxToRem(ICON_SIZES.sm)};
			width: ${pxToRem(ICON_SIZES.sm)};
			background-color: ${$disabled
        ? theme.colors.medium.iconInactiveOnMedium
        : theme.colors.highlight.iconInteractive};
			pointer-events: none;
		}
	`}
`;
export const SelectContainer = styled.div `
	${selectContainerStyles}
`;
export const selectComponentStyles = ({ theme, $invalid, $loading, $colorContext, $color, }) => css `
	appearance: none;
	background-image: none;
	border-style: solid;
	border-color: ${theme.colors.medium.borderFormField};
	border-width: 0 0 ${pxToRem(theme.borderWidth['2'])} 0;
	border-radius: ${theme.borderRadius.s}px ${theme.borderRadius.s}px 0 0;
	color: ${theme.colors.base.textFormFieldInput};
	background-color: ${theme.colors.extralight.bgFormField};
	height: ${pxToRem(SELECT_HEIGHT)};
	text-overflow: ellipsis;
	width: 100%;
	padding-left: ${pxToRem(theme.spacing['200'])};
	${getGenericInputPaddingStyles({ theme, $invalid, $color })}
	padding-right: ${pxToRem(PADDING_RIGHT)};

	${$colorContext === 'on-light' && getOnLightStyles({ theme, $invalid, $color })}

	${$colorContext === 'on-medium' && getOnMediumStyles({ theme, $invalid, $color })}

	${$colorContext === 'on-dark' && getOnDarkStyles({ theme, $invalid, $color })}

	&:focus {
		outline: none;
	}

	&[aria-disabled='true'] {
		opacity: 1;
		color: ${theme.colors.medium.textInactive};
		border-color: ${theme.colors.medium.borderFormField};
		background-color: ${theme.colors.extralight.bgFormFieldDisabled};

		${$colorContext === 'on-medium' &&
    css `
			color: ${theme.colors.medium.textInactiveOnMedium};
			background-color: ${theme.colors.light.bgFormFieldDisabledOnMedium};
		`}
	}

	${$invalid &&
    css `
		border-color: ${theme.colors.error.borderFormField};
	`};

	${$loading &&
    css `
		pointer-events: none;
		padding-right: ${pxToRem(theme.spacing[600])};
	`}
`;
export const SelectComponent = styled(Typography).attrs({
    variant: 'field-text',
    tagName: 'select',
}) `
	${selectComponentStyles}
`;
